import type { AlxPassRow } from './types'

export interface AlxAnomalyWarning {
  fileName: string
  passName: string
  message: string
}

const HIGH_HEAT_KJ_PER_INCH = 200
const LOW_TRAVEL_INCH_PER_MIN = 1

export function detectAlxAnomalies(rows: AlxPassRow[]): AlxAnomalyWarning[] {
  const warnings: AlxAnomalyWarning[] = []
  for (const row of rows) {
    const heat = row.metrics.heatInputKJPerInch
    if (heat !== null && heat > HIGH_HEAT_KJ_PER_INCH) {
      warnings.push({
        fileName: row.fileName,
        passName: row.passName,
        message: `Heat input ${heat.toFixed(1)} KJ/inch is unusually high — source may have been logged in metric units (KJ/mm).`
      })
    }
    const speed = row.metrics.travelSpeedInchPerMin
    if (speed !== null && speed < LOW_TRAVEL_INCH_PER_MIN) {
      warnings.push({
        fileName: row.fileName,
        passName: row.passName,
        message: `Travel speed ${speed.toFixed(3)} inch/min is very low — metric cm/min rounding may make this value unusable.`
      })
    }
  }
  return warnings
}
